<template>
    <div class="app-container">
        <AuthMenubar/>
        <div class="main-wrapper">
            <MobileMenu v-if="$store.state.menuExpanded"/>
            <main :class="{'mobile-menu-expanded': $store.state.menuExpanded}">
                <slot/>
            </main>
        </div>
    </div>
</template>

<script>
    import AuthMenubar from "../components/AuthMenubar";
    import Sidebar from "../components/Sidebar";
    import Footer from "../components/Footer";
    import MobileMenu from "@/components/MobileMenu";

    export default {
        name: "AccountLayout",
        components: {MobileMenu, Footer, Sidebar, AuthMenubar}
    }
</script>

<style lang="scss" scoped>
    .app-container {
        @apply grid h-screen;

        grid-template-columns: auto 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: "menubar menubar" "sidebar content";

        .main-wrapper {
            @apply overflow-auto flex flex-col;

            grid-area: content;

            main {
                @apply flex-1;

                &.mobile-menu-expanded{
                    @apply hidden;

                    @screen md {
                        @apply block;
                    }
                }
            }
        }
    }
</style>